import React, { useEffect, useState } from 'react';
import { Navbar, NavbarBrand } from 'shards-react';
import type { SidebarMainNavbarProps } from '../../../types/common';

import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { sidebarToggle } from '../../../redux/slices/session';


const SidebarMainNavbar: React.FC<SidebarMainNavbarProps> = (props): React.ReactElement => {
  const dispatch = useDispatch();
  const { hideLogoText } = props;


  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);


  // EVENT HANDLER
  // ================================================================================

  const handleSidebarToggle = () => {
    dispatch(sidebarToggle());
  };


  // VIEW
  // ================================================================================

  return (
    <div className="main-navbar">
      <Navbar
        className="align-items-stretch bg-white flex-md-nowrap p-0"
        type="light"
      >
        <NavbarBrand
          className="w-100 mr-0"
          href="/mill-sheet-search"
        >
          <div className="d-flex justify-content-center m-auto">
            <img
              id="main-logo"
              className="d-inline-block align-top mr-1"
              src={`${process.env.PUBLIC_URL}/images/logo_timss_long-3.png`}
              alt="Toyotsu Integrated Millsheet Searching System"
            />
            <img
              id="main-logo-s"
              className="d-inline-block align-top mr-1"
              src={`${process.env.PUBLIC_URL}/images/logo_timss-2.png`}
              alt="Toyotsu Integrated Millsheet Searching System"
            />
            {!hideLogoText && (
              <span className="d-none d-md-inline ml-1">
                Toyotsu Integrated Millsheet Searching System
              </span>
            )}
          </div>
        </NavbarBrand>
        {/* eslint-disable-next-line */}
        <a
          className="toggle-sidebar d-sm-inline-block d-md-inline-block d-lg-inline-block"
          onClick={handleSidebarToggle} 
        >
          <span className="button-toggle"><i className="material-icons text-primary">keyboard_arrow_right</i></span>
        </a>
      </Navbar>
    </div>
  );
};

export default SidebarMainNavbar;
